// Where a signed-out visitor goes back to after signing in.
//
// The app guard sends a signed-out visitor to `/cont/login?next=<path>`, so a link from an email or a
// calendar event (`/notification/<id>`) still lands on its target once the user has signed in. The value
// is read back from the URL, so it is checked before use: only a same-site path counts, never another
// host (`//evil.example`, `/\evil.example`) and never the sign-in pages themselves.

export const DEFAULT_AFTER_SIGN_IN = "/masini";

const AUTH_PAGES = ["/cont/login", "/cont/inregistrare", "/cont/parola-uitata"];

/** The login URL that brings the user back to `path` (pathname + search) after signing in. */
export function loginPathFor(path: string): string {
  const next = safeReturnPath(path);
  return next ? `/cont/login?next=${encodeURIComponent(next)}` : "/cont/login";
}

/** `raw` when it is a same-site path worth returning to, otherwise null. */
export function safeReturnPath(raw: string | null | undefined): string | null {
  if (!raw || !raw.startsWith("/")) return null;
  if (raw.startsWith("//") || raw.startsWith("/\\")) return null;
  const pathname = raw.split(/[?#]/, 1)[0];
  if (AUTH_PAGES.includes(pathname)) return null;
  return raw;
}

/** Where to go after a successful sign-in or sign-up, given the page's `?next=`. */
export function afterSignInPath(next: string | null | undefined): string {
  return safeReturnPath(next) ?? DEFAULT_AFTER_SIGN_IN;
}

/** `?next=…` to carry the return path along a link between the sign-in pages, or "". */
export function nextQuery(next: string | null | undefined): string {
  const safe = safeReturnPath(next);
  return safe ? `?next=${encodeURIComponent(safe)}` : "";
}
